import React, { useEffect, useState } from "react";
import {
  Container,
  Grid,
  Paper,
  Avatar,
  TextField,
  Button,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Divider,
  Typography,
  Box,
  IconButton,
} from "@mui/material";
import avatar from "../../Assets/Images/close-up-portrait-young-bearded-man-white-shirt-jacket-posing-camera-with-broad-smile-isolated-gray_171337-629.jpg";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import TextInput from "../InputComponents/TextInput";
import SelectInput from "../InputComponents/SelectInput";
import { infoNotify } from "../ToastComponent/ToastNotification";

const Profile = () => {
  const [profilePic, setProfilePic] = useState(avatar);
  const [showPassword, setShowPassword] = useState(false);
  const [user, setUser] = useState({
    username: "gene.roding",
    firstName: "Gene",
    lastName: "Rodriguez",
    nickname: "Gene.r",
    role: "Subscriber",
    displayName: "Gene",
    email: "gene.roding@gmail.com",
    website: "gene-roding.webflow.io",
    whatsapp: "@gene-rod",
    telegram: "@gene-rod",
    bio: "Albert Einstein was a German mathematician and physicist who developed the special and general theories of relativity...",
  });

  // Handle Profile Picture Upload
  const handleProfilePicChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const MAX_SIZE_MB = 30;
    const MAX_SIZE_BYTES = MAX_SIZE_MB * 1024 * 1024;

    const fileSizeMB = (file.size / (1024 * 1024)).toFixed(2); // rounded to 2 decimal places

    if (file.size > MAX_SIZE_BYTES) {
      infoNotify(
      `File size should be less than ${MAX_SIZE_MB} MB. Uploaded file size is ${fileSizeMB} MB`
      );
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      setProfilePic(reader.result);
    };
    reader.readAsDataURL(file);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Paper
      elevation={3}
      sx={{
        width: "100%",
        padding: "30px",
        borderRadius: "12px",
        boxShadow: 4,
        minHeight: "100%",
      }}
    >
      <Typography
        variant="h5"
        sx={{
          fontWeight: "bold",
          color: "#0977BC",
          marginBottom: "20px",
          textAlign: "center",
          fontFamily: "Geist, sans-serif",
        }}
      >
        My Profile
      </Typography>

      <Divider sx={{ marginBottom: "20px" }} />

      <Grid container spacing={3}>
        {/* Left Sidebar - Profile Image & Password Change */}
        <Grid item xs={12} md={3} lg={2}>
          <Paper
            elevation={2}
            sx={{
              padding: "20px",
              borderRadius: "12px",
              height: "100%",
              boxShadow: "none",
            }}
          >
            <Box display="flex" flexDirection="column" alignItems="center">
              {/* Circular Profile Picture */}
              <Box
                component="img"
                src={profilePic}
                alt="Profile Picture"
                sx={{
                  width: "150px",
                  height: "150px",
                  borderRadius: "50%", // Circular shape
                  objectFit: "cover", // Ensures the image maintains aspect ratio
                  boxShadow: 2,
                  marginBottom: "10px",
                }}
              />
              <Button
                variant="contained"
                component="label"
                sx={{
                  marginTop: "10px",
                  textTransform: "capitalize",
                  textAlign: "center",
                  fontSize: 14,
                  fontFamily: "Geist, sans-serif",
                }}
                // fullWidth
              >
                Upload Photo
                <input
                  type="file"
                  hidden
                  accept="image/*"
                  onChange={handleProfilePicChange}
                />
              </Button>
            </Box>
          </Paper>
        </Grid>

        {/* Right Section - Profile Details */}
        <Grid item xs={12} md={9} lg={10}>
          <Paper
            elevation={2}
            sx={{
              padding: "20px",
              borderRadius: "12px",
              height: "100%",
              boxShadow: "none",
            }}
          >
            {/* Profile Information */}
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                color: "#0977BC",
                fontFamily: "Geist, sans-serif",
              }}
            >
              Profile Information
            </Typography>

            <Grid
              container
              sx={{
                border: "1px solid lightgrey",
                borderRadius: "10px",
                padding: "20px",
              }}
            >
              {/*  First Name */}
              <Grid item xs={12} sm={6} sx={{ padding: "5px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
                >
                  First Name
                </Typography>
                <TextInput
                  label="Full Name"
                  placeholder="Enter First Name"
                  name="fullName"
                  onChange={() => {}}
                />
              </Grid>
              {/*  Last Name */}
              <Grid item xs={12} sm={6} sx={{ padding: "5px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
                >
                  Last Name
                </Typography>
                <TextInput
                  label="Full Name"
                  placeholder="Enter Last Name"
                  name="fullName"
                  onChange={() => {}}
                />
              </Grid>

              {/* Date of Birth */}
              <Grid item xs={12} sm={6} sx={{ padding: "5px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
                >
                  Date of Birth
                </Typography>
                <TextInput
                  label="Date of Birth"
                  placeholder="Date of Birth"
                  name="dateofbirth"
                  type="date"
                  onChange={() => {}}
                />
              </Grid>

              {/*  Contact Number */}
              <Grid item xs={12} sm={6} sx={{ padding: "5px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
                >
                  Contact Number
                </Typography>
                <TextInput
                  placeholder="Enter Phone Number"
                  type="text"
                  name="phoneNumber"
                  onChange={() => {}}
                />
              </Grid>

              {/* Email */}
              <Grid item xs={12} sm={6} sx={{ padding: "5px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
                >
                  Email
                </Typography>
                <TextInput
                  label="Email Address"
                  placeholder="Enter Email Address"
                  type="email"
                  name="email"
                  onChange={() => {}}
                />
              </Grid>

              {/* Address */}
              <Grid item xs={12} sm={6} sx={{ padding: "5px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
                >
                  Address
                </Typography>
                <TextInput
                  label="Address"
                  placeholder="Enter Address"
                  name="address"
                  onChange={() => {}}
                />
              </Grid>
            </Grid>

            {/* Profile Information */}
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                color: "#0977BC",
                marginTop: "20px",
                fontFamily: "Geist, sans-serif",
              }}
            >
              Official Details
            </Typography>
            <Grid
              container
              sx={{
                border: "1px solid lightgrey",
                borderRadius: "10px",
                padding: "20px",
              }}
            >
              {/* Username */}
              <Grid item xs={12} sm={6} sx={{ padding: "5px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
                >
                  Username <span style={{ color: "red" }}> * </span>
                </Typography>
                <TextInput
                  label="Username"
                  placeholder="Username"
                  name="username"
                  onChange={() => {}}
                />
              </Grid>

              {/* Role */}
              <Grid item xs={12} sm={6} sx={{ padding: "5px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
                >
                  Role
                </Typography>
                <SelectInput
                  onChange={() => {}}
                  options={[
                    { value: "admin", label: "Admin" },
                    { value: "hr", label: "HR" },
                    { value: "recruiter", label: "Recruiter" },
                    { value: "marketingteam", label: "Marketing Team" },
                  ]}
                  placeholder="Select Role"
                  value="admin"
                />
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default Profile;
